<section id="vehicle-data" class="section-padding">
  <div class="container">
    <div class="row s-header">
      <div class="col-md-12">
        <h2>Araç (Katalog) Verileri</h2>
      </div>
    </div>
    <div class="row s-body">
      <div class="col-md-4">
        <div class="data-cell">
          <i class="sprite icon-veri1"></i>
          <span>Marka / Model / Model Tipi<br />Yapı Ağacı Datası</span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="data-cell">
          <i class="sprite icon-veri2"></i>
          <span>Teknik ve Donanım Datası</span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="data-cell">
          <i class="sprite icon-veri6"></i>
          <span>Geçmiş Yılların Araç Datası</span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="data-cell">
          <i class="sprite icon-veri4 lira"></i>
          <span>0 Km Araç Fiyatları</span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="data-cell">
          <i class="sprite icon-veri5 lira"></i>
          <span>2.El Araç Fiyatları</span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="data-cell">
          <i class="sprite icon-veri3"></i>
          <span>Araç Resim Datası</span>
        </div>
      </div>

    </div>
    <div class="row s-footer">
      <div class="col-md-12 tac">
        <a [routerLink]="['/contact']" class="btn btn-primary btn-m">Detaylı Bilgi için İletişime Geçin</a>
      </div>
    </div>
  </div>
</section>
<section id="vehicle-data" class="vehicle-data2 section-padding">
  <div class="container">
    <div class="row s-body justify-content-center">
      <div class="col-md-3">
        <div class="data-cell">
          <a [routerLink]="['/bayimiz-olun']"><span>Cardata Bayisi Olun <span>(Büyüyen Bayilik Ağımıza Siz de
                Katılın!)</span></span></a>
        </div>
      </div>
      <div class="col-md-3">
        <div class="data-cell">
          <span>Geçmiş Yılların<br />2.El Araç Fiyatları <span>(Türkiye’de Bir İlk!)</span></span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="data-cell">
          <span>Araç Değer Kaybı <span>(Aracının Değer Kaybını Hemen Öğren)</span></span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="data-cell">
          <span>Satın Almak İçin<br />Hangi Aracı Arıyorsun<span>(Kişisel Araç Bulma Asistanınız)</span></span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="data-cell">
          <span>Araç<br />Hasar Endeksi</span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="data-cell">
          <span>Hangi Aracın<br />2.El Değeri Yüksek</span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="data-cell">
          <span>Aracınızın<br />Gelecekteki Piyasa Değeri</span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="data-cell">
          <span>Aracınızı Biz Satalım!<br />Bize Konsinye Bırak!</span>
        </div>
      </div>
      <div class="col-md-12 tac">
        <a [routerLink]="['/contact']" class="btn btn-primary btn-m">Detaylı Bilgi için İletişime Geçin</a>
      </div>
    </div>
  </div>
</section>